"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BACK_TO_TOP_DISTANCE", {
  enumerable: true,
  get: function get() {
    return _BackToTop.BACK_TO_TOP_DISTANCE;
  }
});
Object.defineProperty(exports, "BACK_TO_TOP_POSITION", {
  enumerable: true,
  get: function get() {
    return _BackToTop.BACK_TO_TOP_POSITION;
  }
});
exports.BackToTop = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactScroll = require("react-scroll");
var _useWindowScroll2 = _interopRequireDefault(require("react-use/lib/useWindowScroll"));
var _common = require("b2b-components/theme/common");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _BackToTop = require("./BackToTop.types");
require("./BackToTop.scss");
var BackToTop = function BackToTop(_ref) {
  var className = _ref.className,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? _BackToTop.BACK_TO_TOP_DISTANCE : _ref$distance,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? _BackToTop.BACK_TO_TOP_POSITION.fixed : _ref$position;
  var _useWindowScroll = (0, _useWindowScroll2["default"])(),
    scrollY = _useWindowScroll.y;
  var handleClick = function handleClick(e) {
    e.preventDefault();
    _reactScroll.animateScroll.scrollToTop({
      duration: _common.SCROLL_DURATION
    });
  };
  var rootClassName = (0, _classnames["default"])('cds-BackToTop', "cds-BackToTop--".concat((0, _upperCaseFirst.upperCaseFirst)(position)), {
    'cds-BackToTop--InView': scrollY >= distance
  }, className);
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: rootClassName,
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.toplink,
    className: "cds-BackToTop-Icon"
  }));
};
exports.BackToTop = BackToTop;
BackToTop.config = {
  distanceToTop: _BackToTop.BACK_TO_TOP_DISTANCE,
  position: _BackToTop.BACK_TO_TOP_POSITION
};